import { IClassname } from '@/lib/shared/model/classname';

export const SuitableForFamily = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14276_619)">
        <path
          d="M19.8338 17.9268C18.817 17.9268 17.8418 18.3307 17.1229 19.0496C16.4039 19.7686 16 20.7437 16 21.7605V24.9553H17.9169L18.5558 30.7059H21.1117L21.7506 24.9553H23.6675V21.7605C23.6675 20.7437 23.2636 19.7686 22.5446 19.0496C21.8257 18.3307 20.8505 17.9268 19.8338 17.9268Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.2099 14.5826C25.8358 14.7709 26.5018 14.781 27.133 14.6117C27.7643 14.4424 28.3358 14.1004 28.7834 13.6241C29.231 13.1479 29.5369 12.5562 29.6668 11.9157C29.7967 11.2752 29.7454 10.6111 29.5186 9.99812C29.2918 9.38514 28.8986 8.84754 28.3832 8.44573C27.8677 8.04392 27.2504 7.79381 26.6006 7.72351C25.9508 7.65322 25.2943 7.76551 24.7048 8.04778C24.1154 8.33006 23.6163 8.77112 23.2637 9.32142"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.0552 16.1618C25.4363 16.0604 25.8289 16.0093 26.2232 16.0098C27.4095 16.0098 28.5471 16.481 29.3859 17.3198C30.2247 18.1586 30.6959 19.2962 30.6959 20.4825V24.3162H28.673L28.1401 30.7058H24.3064L24.0508 27.6388"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4613 7.22134C16.4016 7.28358 16.33 7.3331 16.2507 7.36693C16.1715 7.40077 16.0861 7.41821 15.9999 7.41821C15.9138 7.41821 15.8284 7.40077 15.7492 7.36693C15.6699 7.3331 15.5983 7.28358 15.5386 7.22134L12.8882 4.45721C12.6169 4.18352 12.4383 3.8316 12.3775 3.45103C12.3168 3.07046 12.3769 2.68043 12.5496 2.33586C12.6798 2.07614 12.8698 1.85095 13.1038 1.67874C13.3378 1.50652 13.6093 1.39217 13.896 1.34505C14.1828 1.29793 14.4766 1.31938 14.7534 1.40763C15.0302 1.49588 15.2822 1.64844 15.4888 1.85281L15.9999 2.36398L16.5111 1.85281C16.7174 1.64646 16.9697 1.4921 17.2474 1.40247C17.525 1.31284 17.82 1.29051 18.1079 1.33732C18.3959 1.38413 18.6686 1.49873 18.9036 1.67169C19.1385 1.84464 19.329 2.07098 19.4593 2.33203C19.632 2.67768 19.6916 3.06889 19.6297 3.4503C19.5678 3.8317 19.3874 4.18396 19.1142 4.45721L16.4613 7.22134Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1663 19.2041C13.183 19.2041 14.1582 19.608 14.8771 20.327C15.5961 21.046 16 22.0211 16 23.0379V26.2326H14.0831L13.4442 30.7054H10.8884L10.2494 26.2326H8.33252V23.0379C8.33252 22.0211 8.73643 21.046 9.4554 20.327C10.1744 19.608 11.1495 19.2041 12.1663 19.2041Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.79013 14.5826C6.16428 14.7709 5.49831 14.781 4.86705 14.6117C4.23579 14.4424 3.66425 14.1004 3.21665 13.6241C2.76905 13.1479 2.46313 12.5562 2.33326 11.9157C2.20339 11.2752 2.25472 10.6111 2.48148 9.99812C2.70824 9.38514 3.10144 8.84754 3.61691 8.44573C4.13237 8.04392 4.74968 7.79381 5.39946 7.72351C6.04925 7.65322 6.70576 7.76551 7.29523 8.04778C7.88471 8.33006 8.38379 8.77112 8.7364 9.32142"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.94468 16.1618C6.56365 16.0604 6.17097 16.0093 5.77666 16.0098C4.59043 16.0098 3.45278 16.481 2.61398 17.3198C1.77519 18.1586 1.30396 19.2962 1.30396 20.4825V24.3162H3.3269L3.85979 30.7058H7.69354L7.829 29.0739"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.61035 15.3713C9.61035 16.0491 9.87963 16.6992 10.3589 17.1785C10.8382 17.6578 11.4883 17.9271 12.1662 17.9271C12.844 17.9271 13.4941 17.6578 13.9734 17.1785C14.4527 16.6992 14.722 16.0491 14.722 15.3713C14.722 14.6934 14.4527 14.0433 13.9734 13.564C13.4941 13.0847 12.844 12.8154 12.1662 12.8154C11.4883 12.8154 10.8382 13.0847 10.3589 13.564C9.87963 14.0433 9.61035 14.6934 9.61035 15.3713Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2778 14.0929C17.2778 14.7708 17.5471 15.4209 18.0264 15.9002C18.5057 16.3795 19.1558 16.6488 19.8337 16.6488C20.5115 16.6488 21.1616 16.3795 21.6409 15.9002C22.1202 15.4209 22.3895 14.7708 22.3895 14.0929C22.3895 13.4151 22.1202 12.765 21.6409 12.2857C21.1616 11.8064 20.5115 11.5371 19.8337 11.5371C19.1558 11.5371 18.5057 11.8064 18.0264 12.2857C17.5471 12.765 17.2778 13.4151 17.2778 14.0929Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14276_619">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.00976562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
